import I18n from 'I18n';
import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeedbackSurveyCharacterCounter = ({
  placeholder,
  setFollowUp,
  label
}) => {
  const hasValidLabel = isValidI18nKey('growth-onboarding-feedback-components.feedbackModal.characterCounter.label');
  const hasValidPlaceholder = isValidI18nKey('growth-onboarding-feedback-components.feedbackModal.characterCounter.placeholder');
  return /*#__PURE__*/_jsx(FormControl, {
    label:
    // If no label is provided, use the default label if loaded successfully, otherwise use an empty string
    label || (hasValidLabel ? I18n.text('growth-onboarding-feedback-components.feedbackModal.characterCounter.label') : ''),
    children: /*#__PURE__*/_jsx(CharacterCounter, {
      counter: "down",
      max: 1500,
      maxLength: 1500,
      renderInput: ({
        onChange,
        value
      }) => /*#__PURE__*/_jsx(TextArea, {
        rows: 3,
        placeholder:
        // If no placeholder is provided, use the default placeholder if loaded successfully, otherwise use an empty string
        placeholder || (hasValidPlaceholder ? I18n.text('growth-onboarding-feedback-components.feedbackModal.characterCounter.placeholder') : ''),
        autoFocus: true,
        value: value,
        onChange: onChange
      }),
      onChange: ({
        target: {
          value
        }
      }) => {
        setFollowUp(value);
      }
    })
  });
};